import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import {
  useController,
  UseControllerReturn,
  useFormContext,
} from "react-hook-form";
import { InputProps } from "./TextInput";
import '../styles/global.css'

export interface SelectInputOption {
  value: number;
  title?: string;
}

export interface SelectInputProps extends InputProps {
  options: SelectInputOption[];
  index?: number
  value?: number
}

export const SelectInput = (props: SelectInputProps) => {
  const { control } = useFormContext();

  const controller: UseControllerReturn = useController({
    name: props.name,
    control,
  });


  // control.register(`_${props.name}`, { value: true }) 
  

    return (
      <FormControl fullWidth size="small"
        sx={{
          "& .MuiFormLabel-root": {
            fontSize: '0.9em'
          },
          "& .MuiInputBase-root": {
            fontSize: '0.9em', height: 35
          },
        }}
        error={!!controller.fieldState.error}
      >
        <InputLabel 
        id={props.label}
        >
          {props.label}
          </InputLabel>
        <Select
          sx={{
            "& .MuiFormLabel-root": {
              fontSize: '0.9em'
            },
            "& .MuiInputBase-root": {
              fontSize: '0.9em', height: 35
            }
          }}
          variant="outlined"
          size="small"
          id={props.name}
          defaultValue=""
          label={props.label}
          onChange={controller.field.onChange}
          onBlur={controller.field.onBlur}
          name={controller.field.name}
          ref={controller.field.ref}
          value={controller.field.value}
          // disabled={true}
        >
          {props.options.map((option: SelectInputOption) => (
            <MenuItem key={option.value} value={option.value}>
              {option.title}
            </MenuItem>
          ))}
        </Select>
        {!!controller.fieldState.error &&
          <FormHelperText error={!!controller.fieldState.error}>
            {controller.fieldState.error?.message}
          </FormHelperText>
        }
      </FormControl>
    )
};
